import { useState } from 'react';
import { Button } from "src/@/components/ui/button";
import { Card } from "src/@/components/ui/card";
import Iconify from 'src/components/Iconify';
import ChatInternoMessagesList from './ChatInternoMessagesList';
import ChatInternoBottombar from './ChatInternoBottombar';
import { useSelector } from 'react-redux';
import useAuth from 'src/hooks/useAuth';
import { useNavigate } from 'react-router';
import { getChatInternoBuscarChat, setSelectedChat } from 'src/redux/slices/staff';
import { clearSessionStorageItem, getSessionStorageItem } from 'src/services/sessionStorage';
import { useEffect } from 'react';


const ItemButtonWindow = ({ title, onClick, icon }) => {
  return (
    <Button
      onClick={onClick}
      className="hover:bg-slate-700 focus:ring-gray-700"
      size="sm"
      variant="icon"
    >
      <Iconify icon={icon} className="text-white" />
    </Button>
  )
}

const ChatInternoMiniChat = ({chat}) => {
  const [isMinimized, setIsMinimized] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();
  const { room, loadingMsg } = useSelector((state) => state.staff);
  const [chatInternoMini, setChatInternoMini] = useState();



  let titleGroup;
  if(chat?.isGroup) {
    titleGroup = chat.title;
  } else {
    // filtrando usaurio do chat que é diferente do usuario logado
    const person = chat && chat?.people[0];
    titleGroup = person ? `${person.nomeFantasia}` : '';
  }

  const handleMinimize = () => {
    setIsMinimized(!isMinimized);
  };

  const handleNavToChat = () => {
    const target = `/chats/interno/${chat._id}`;
    navigate(target);
    dispatch(getChatInternoBuscarChat(chat._id))
    dispatch(setSelectedChat(chat))
  };

  useEffect(() => {
    const handleStorageChange = () => {
      setChat(JSON.parse(sessionStorage.getItem('chatInternoMiniId')));
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
 

  return (
    <div className="fixed bottom-0 right-0  mr-4 z-50 rounded-t-md">
    <Card className={`w-84 -mb-1 bg-white shadow-lg rounded-lg ${isMinimized ? 'h-12' : 'h-[500px] '} max-w-84`}>
      <div 
      onClick={handleMinimize}
      className="flex cursor-pointer items-center justify-between p-1 bg-slate-900 text-white rounded-t-md w-84">
        <span className='text-[12px] font-medium ml-1'>{titleGroup}</span>
        <div className='flex gap-1'>
          <Button 
            className="hover:bg-slate-700 focus:ring-gray-700" 
            size="sm" 
            variant="icon"
            onClick={() => {
              clearSessionStorageItem('chatInternoMiniId');
              setIsMinimized(true);
            }}
          >
            <Iconify icon="mdi:close" className="text-white" />
          </Button>
          <Button 
            className="hover:bg-slate-700 focus:ring-gray-700" 
            size="sm" 
            variant="icon"
            onClick={handleNavToChat}
          >
            <Iconify icon="pepicons-pencil:expand" className="text-white" />
          </Button>
          <Button 
            className="hover:bg-gray-700 focus:ring-gray-700" 
            size="sm" 
            variant="icon"
            onClick={handleMinimize}
          >
            <Iconify icon={isMinimized ? "akar-icons:chevron-up" : "akar-icons:chevron-down"} className="text-white" />
          </Button>
        </div>
      </div>
      
      {!isMinimized && (
        <div className='flex flex-col h-full'>
          <div className="overflow-y-auto flex-grow">
            <ChatInternoMessagesList isMiniChat />
          </div>
          <div className="mb-8">
            <ChatInternoBottombar chat={chat} />
          </div>
        </div>
      )}
    </Card>
  </div>
  );
};

export default ChatInternoMiniChat;
